/*@flow*/
import { useEffect } from 'react';
import Blank from 'lib/Blank';
import useCommands from './useCommands';
import useContextState from './useContextState';
import queryUUIDPaths from './queryUUIDPaths';
import useLayerQueries from './useLayerQueries';

export default function useLayerActivator() {
  const layerQuery = useLayerQueries();
  const { layersLoadedQueryMap } = useContextState();
  const cmd = useCommands();

  useEffect(() => {
    if (Blank.is(layersLoadedQueryMap)) return;
    const qps = queryUUIDPaths(layerQuery);

    // Filter only the loaded layers, i.e. the ones in layersLoadedQueryMap.
    qps.forEach((path) => {
      const key = path.join('|');
      const uuid = layersLoadedQueryMap.get(key);
      // for each key path in query string find the layer id
      if (uuid) {
        // add the layer id to active layers, if not already added
        cmd.update(['layersActiveLayers'], (v) =>
          v.has(uuid) ? v : v.add(uuid)
        );
      }
    });
  }, [layersLoadedQueryMap.hashCode(), layerQuery.hashCode()]);
}
